import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "backArrow",
  "use": "backArrow-usage",
  "viewBox": "0 0 23 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 23 13\" id=\"backArrow\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M20.502 4.977H5.037L7.142 2.89a1.364 1.364 0 000-1.937 1.387 1.387 0 00-.977-.391 1.39 1.39 0 00-.974.391L.733 5.378a1.37 1.37 0 000 1.938l4.459 4.425c.261.258.607.4.974.4.368 0 .714-.142.976-.4a1.365 1.365 0 000-1.937L5.036 7.715h15.465c1.337 0 2.19-.232 2.19-1.364 0-1.132-.853-1.374-2.19-1.374z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol